(() => {
  if (window.aceFamiliarProductReady) return;
  window.aceFamiliarProductReady = true;
  const phone = window.matchMedia('(max-width: 767px)');
  const prepared = new WeakSet();
  const initialise = scope => {
    for (const group of scope.querySelectorAll('.hdt-type-tab-accordion')) {
      if (prepared.has(group)) continue;
      prepared.add(group);
      if (!phone.matches) continue;
      for (const details of group.querySelectorAll('details.hdt-product-accordion__item')) {
        details.open = false;
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    }
  };
  const start = () => initialise(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  // Closed mobile details must not hide a desktop tab after a viewport change.
  phone.addEventListener('change', () => {
    if (phone.matches) return;
    for (const details of document.querySelectorAll('.hdt-type-tab-accordion hdt-accordion > details.hdt-product-accordion__item')) {
      details.open = true;
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    }
  });


  // Private enquiries use the native Kalles dialog and Shopify contact form.
  // Keep public Judge.me questions available below as a separate destination.
  const enquiryVariants = new WeakMap();
  document.addEventListener('variant:change', event => {
    if (event.target instanceof HTMLFormElement) enquiryVariants.set(event.target, event.detail?.variant ?? null);
  }, true);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-ace-corporate-enquiry]');
    if (!trigger) return;
    const dialog = document.getElementById('modal-contactFormAsk');
    if (!dialog) return;
    const productForm = document.getElementById(trigger.dataset.productForm);
    const scope = trigger.closest('.hdt-product-info__list') || trigger.closest('dialog') || document;
    const picker = scope.querySelector('hdt-variant-picker');
    let variant;
    if (productForm && enquiryVariants.has(productForm)) variant = enquiryVariants.get(productForm);
    else {
      try { variant = JSON.parse(picker?.querySelector('script[type="application/json"]')?.textContent || 'null'); }
      catch (_) { variant = null; }
      if (!picker) variant = {id:trigger.dataset.variantId,title:trigger.dataset.variantTitle,sku:trigger.dataset.variantSku};
    }
    const title = trigger.dataset.productTitle || '';
    const option = variant?.title && variant.title !== 'Default Title' ? variant.title : '';
    const sku = variant?.sku || '';
    const url = new URL(trigger.dataset.productUrl, location.origin);
    if (variant?.id) url.searchParams.set('variant', String(variant.id));
    const productText = [title,option,sku ? 'SKU: '+sku : '',url.href].filter(Boolean).join('\n');
    trigger.setAttribute('data-product', productText);
    const put = (selector, value) => { const field=dialog.querySelector(selector); if(field) field.value=value; };
    put('[data-ace-enquiry-product]',productText);
    put('[data-ace-enquiry-option]',option);
    put('[data-ace-enquiry-sku-field]',sku);
    put('[data-ace-enquiry-url]',url.href);
    const summary=dialog.querySelector('[data-ace-enquiry-summary]');
    if(summary) summary.hidden=false;
    for(const [selector,value] of [['[data-ace-enquiry-title]',title],['[data-ace-enquiry-variant]',option],['[data-ace-enquiry-sku]',sku ? 'SKU: '+sku : '']]){
      const text=dialog.querySelector(selector);if(text){text.textContent=value;text.hidden=!value;}
    }
  }, true);
  const enquiryDialog=document.getElementById('modal-contactFormAsk');
  if(enquiryDialog){
    const expanded=value=>document.querySelectorAll('[data-ace-corporate-enquiry]').forEach(button=>button.setAttribute('aria-expanded',String(value)));
    enquiryDialog.addEventListener('dialog:opening',()=>expanded(true));
    enquiryDialog.addEventListener('dialog:open',()=>expanded(true));
    enquiryDialog.addEventListener('dialog:closing',()=>expanded(false));
    enquiryDialog.addEventListener('close',()=>expanded(false));
  }


  // Shopify renders the challenge outside the dialog. Release the top layer
  // on a valid submission so its verification UI is visible and operable.
  document.addEventListener('submit', event => {
    if (event.target?.id !== 'ContactFormAsk' || !event.target.checkValidity()) return;
    const dialog = document.getElementById('modal-contactFormAsk');
    if (!dialog?.open) return;
    queueMicrotask(() => { if (dialog.open) dialog.parentElement.close(true); });
  }, true);

  // One product-question destination: use Judge.me's own form and handlers.
  // Never copy its markup, initialise it again, or bypass its validation.
  const visible = element => element && element.getClientRects().length > 0 &&
    getComputedStyle(element).visibility !== 'hidden';
  const waitForMatch = (scope, selector, accept = visible, timeout = 15000) => new Promise(resolve => {
    const current = scope.querySelector(selector);
    if (accept(current)) return resolve(current);
    const observer = new MutationObserver(() => {
      const element = scope.querySelector(selector);
      if (!accept(element)) return;
      observer.disconnect();
      clearTimeout(timer);
      resolve(element);
    });
    const timer = setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, timeout);
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  });
  let questionOpening = false;
  const openProductQuestion = async (widget, trigger) => {
    if (questionOpening) return;
    questionOpening = true;
    trigger?.setAttribute('aria-busy', 'true');
    widget.scrollIntoView({ block: 'start', behavior: 'auto' });
    try {
      const nativeAsk = await waitForMatch(widget, '.jdgm-ask-question-btn');
      if (!nativeAsk) {
        widget.querySelector('.jdgm-subtab__name[data-tabname="questions"]')?.focus({ preventScroll: true });
        return;
      }
      // Judge.me lazy-loads and re-renders its Ask control before binding the
      // question form. A first click can only load that module. Wait for its
      // native form to exist, then re-acquire the current (bound) control.
      let form = widget.querySelector('.jdgm-question-form');
      if (!form) {
        nativeAsk.click();
        form = await waitForMatch(widget, '.jdgm-question-form', element => !!element);
      }
      if (!form) return;
      const readyAsk = widget.querySelector('.jdgm-ask-question-btn');
      if (!visible(form) && readyAsk?.getAttribute('aria-expanded') !== 'true') readyAsk?.click();
      form = await waitForMatch(widget, '.jdgm-question-form');
      if (!form) return;
      form.scrollIntoView({ block: 'start', behavior: 'auto' });
      form.querySelector('input:not([type="hidden"]), textarea')?.focus({ preventScroll: true });
    } finally {
      trigger?.removeAttribute('aria-busy');
      questionOpening = false;
    }
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-ace-ask-question]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    // A quick-view question should open that product's full Q&A, not the
    // underlying page's different product. The href also works without JS.
    if (trigger.closest('dialog, [role="dialog"]')) return;
    const widget = document.getElementById('judgeme_product_reviews');
    if (!widget || widget.dataset.id !== trigger.dataset.aceAskQuestion) return;
    event.preventDefault();
    // Finish the originating link action before activating the native control.
    setTimeout(() => openProductQuestion(widget, trigger), 0);
  });
  const openLinkedQuestion = () => {
    if (location.hash !== '#ace-product-questions') return;
    const widget = document.getElementById('judgeme_product_reviews');
    if (widget) openProductQuestion(widget);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openLinkedQuestion, { once: true });
  else openLinkedQuestion();
  window.addEventListener('hashchange', openLinkedQuestion);

  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-ace-open-description]');
    if (!trigger) return;
    const main = trigger.closest('[data-ace-main-product]');
    if (!main || main.dataset.aceMainProduct !== trigger.dataset.aceOpenDescription) return;
    const tabs = document.querySelector('.hdt-product-tab');
    const panel = tabs?.querySelector('[tab-item].hdt-product-description');
    if (!panel) return;
    event.preventDefault();
    await customElements.whenDefined('hdt-tab');
    const tab = tabs.querySelector('hdt-tab');
    const tabButton = tab?.querySelector('button');
    // Retain the native tab controller's active index when Read more is used.
    tabButton?.click();
    const details = panel.querySelector('details');
    if (details && !details.open) {
      await customElements.whenDefined('hdt-accordion');
      details.closest('hdt-accordion')?.toggle(true);
    }
    setTimeout(() => {
      const target = phone.matches ? details?.querySelector('summary') : tabButton;
      target?.focus({ preventScroll: true });
      (target || panel).scrollIntoView({ block: 'start', behavior: 'auto' });
    }, 350);
  });
})();
